import React from 'react';
import { Space, Typography } from 'antd';
import type { WeldMeta } from './types';

const { Text } = Typography;

interface Props {
  meta?: WeldMeta;
  /** BC/VC/UT panellerinde Fluid satırı var, PT/MT'de yok (mevcut davranış) */
  showFluid?: boolean;
}

/** RFI'dan gelen read-only weld meta satırı — panel başına kopyalanan bloğun teki. */
export default function WeldMetaBlock({ meta, showFluid = true }: Props) {
  return (
    <div style={{ padding: 4, backgroundColor: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 4, marginBottom: 6 }}>
      <Space size={8} wrap>
        <Text strong>Size:</Text>
        <Text>{meta?.pipe_size ?? '-'}</Text>
        <Text strong>Service:</Text>
        <Text>{meta?.service_class_name ?? '-'}</Text>
        {showFluid && <Text strong>Fluid:</Text>}
        {showFluid && <Text>{meta?.fluid ?? '-'}</Text>}
        <Text strong>Type:</Text>
        <Text>{meta?.weldtype_name ?? '-'}</Text>
        <Text strong>Spool:</Text>
        <Text>{meta?.spool_id ?? '-'}</Text>
        <Text strong>F/S:</Text>
        <Text>{meta?.weld_category ?? '-'}</Text>
        <Text strong>Code:</Text>
        <Text>{meta?.code_no ?? '-'}</Text>
      </Space>
    </div>
  );
}
